export default [
  // 添加学员
  {
    name: 'add-student-popup',
    component: () => import(/* webpackChunkName: "addStudentPopup" */ './add-student-popup.vue'),
  },
  // 修改日期弹框
  {
    name: 'md-date',
    component: () => import(/* webpackChunkName: "addStudentPopup" */ './md-date.vue'),
  },
  // 复课弹框
  {
    name: 'set-student-class-recovery',
    component: () => import(/* webpackChunkName: "setStudentRecoveryClass" */ './set-student-recovery-class.vue'),
  },
  // 停课弹框
  {
    name: 'set-student-class-stop',
    component: () => import(/* webpackChunkName: "setStudentStopClass" */ './set-student-stop-class.vue'),
  },
  // 通知家长采集弹框
  {
    name: 'send-parent-to-fase',
    component: () => import(/* webpackChunkName: "sendParentToFase" */ './send-parent-to-fase.vue'),
  },
  // 通知家长绑定弹框
  {
    name: 'send-parent-to-fase-app',
    component: () => import(/* webpackChunkName: "sendParentToFaseApp" */ './send-parent-to-fase-app.vue'),
  },
  // 检查学员同名弹框
  {
    name: 'add-student-repeat-name',
    component: () => import(/* webpackChunkName: "addStudentRepeatName" */ './add-student-repeat-name.vue'),
  },
  // 学员入班选择日期
  {
    name: 'stu-attend-class-date',
    component: () => import(/* webpackChunkName: "stu-attend-class-date" */ './stu-attend-class-date.vue'),
  },
  // 查看出勤率
  {
    name: 'stu-attendance-detail',
    component: () => import(/* webpackChunkName: "stu-attendance-detail" */ './stu-attendance-detail.vue'),
  },
  // 学员加减积分
  {
    name: 'stu-member-score',
    component: () => import(/* webpackChunkName: "stu-member-score" */ './stu-member-score.vue'),
  },
  // 学员批量转曾就读结果页
  {
    name: 'set-student-studied',
    component: () => import(/* webpackChunkName: "set-student-studied" */ './set-student-studied.vue'),
  },
];
